var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-faq" }, [
    _c("header", { staticClass: "tls-simple-banner" }, [
      _c("div", { staticClass: "tls-home-text-group" }, [
        _c("h1", { staticClass: "tls-heading-1" }, [
          _vm._v(_vm._s(_vm._.get(_vm.cmsData, "primary_title")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tls-static-content tls-faq-content" },
      [
        _c("div", { staticClass: "tls-large-card-info" }, [
          _c("div", { staticClass: "tls-card-lg" }, [
            _c("div", { staticClass: "tls-simple-text -size-16" }, [
              _c("p", [_vm._v(_vm._s(_vm._.get(_vm.cmsData, "information")))])
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c(
          "el-input",
          {
            staticClass: "tls-faq-input",
            attrs: {
              placeholder: _vm._.get(_vm.cmsData, "input_placeholder"),
              clearable: ""
            },
            model: {
              value: _vm.searchContent,
              callback: function($$v) {
                _vm.searchContent = $$v
              },
              expression: "searchContent"
            }
          },
          [
            _c("i", {
              staticClass: "el-icon-search el-input__icon",
              attrs: { slot: "prefix" },
              slot: "prefix"
            })
          ]
        ),
        _vm._v(" "),
        _vm.searchContent.trim().length === 0
          ? _c("div", [
              !_vm.cmsData.hide_faq_content
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "tls-faq-action", attrs: { id: "top" } },
                      [
                        _c("div", { staticClass: "tls-faq-action--slot" }, [
                          _c("h2", { staticClass: "tls-heading-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm._.get(_vm.cmsData, "action_button_title1")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._.get(_vm.cmsData, "action_button_name1") &&
                        _vm._.get(_vm.cmsData, "redirect_link1")
                          ? _c("div", { staticClass: "tls-faq-action--slot" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "tls-button-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.redirectPage("redirect_link1")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.cmsData,
                                          "action_button_name1"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "tls-faq-action--slot" }, [
                          _c("h2", { staticClass: "tls-heading-2" }, [
                            _vm._v(
                              _vm._s(_vm._.get(_vm.cmsData, "action_sub_title"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tls-faq-action--slot" }, [
                          _c("div", { staticClass: "tls-faq-action-text" }, [
                            _c(
                              "ul",
                              [
                                _vm._l(
                                  _vm._.sortBy(
                                    _vm.contentSlotDataWithoutCategory,
                                    "sort"
                                  ),
                                  function(contentSlotData, index) {
                                    return [
                                      _vm._.get(
                                        contentSlotData,
                                        "slot_title_translation"
                                      )
                                        ? _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass: "tls-link-list--slot"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "tls-link",
                                                  attrs: {
                                                    href:
                                                      _vm._.get(
                                                        _vm.path,
                                                        "path"
                                                      ) +
                                                      "#" +
                                                      _vm._.get(
                                                        contentSlotData,
                                                        "anchor"
                                                      )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._.get(
                                                        contentSlotData,
                                                        "slot_title_translation"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.allCategoryAfterDeduplication, function(
                          category,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _c("div", { staticClass: "tls-faq-action--slot" }, [
                              _c("h2", { staticClass: "tls-heading-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._.get(category, "faq_category_name")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tls-faq-action--slot" }, [
                              _c(
                                "div",
                                { staticClass: "tls-faq-action-text" },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "tls-link-list" },
                                    [
                                      _vm._l(
                                        _vm._.sortBy(
                                          _vm._.filter(
                                            _vm.contentSlotDataWithCategory,
                                            ["faq_category.name", category.name]
                                          ),
                                          "sort"
                                        ),
                                        function(contentSlotData, index) {
                                          return [
                                            _vm._.get(
                                              contentSlotData,
                                              "slot_title_translation"
                                            )
                                              ? _c(
                                                  "li",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "tls-link-list--slot"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "tls-link",
                                                        attrs: {
                                                          href:
                                                            _vm._.get(
                                                              _vm.path,
                                                              "path"
                                                            ) +
                                                            "#" +
                                                            _vm._.get(
                                                              contentSlotData,
                                                              "anchor"
                                                            )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._.get(
                                                              contentSlotData,
                                                              "slot_title_translation"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        _vm._.get(_vm.cmsData, "action_button_title2")
                          ? _c("div", { staticClass: "tls-faq-action--slot" }, [
                              _c("h2", { staticClass: "tls-heading-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._.get(
                                      _vm.cmsData,
                                      "action_button_title2"
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._.get(_vm.cmsData, "action_button_name2") &&
                        _vm._.get(_vm.cmsData, "redirect_link2")
                          ? _c("div", { staticClass: "tls-faq-action--slot" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "tls-button-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.redirectPage("redirect_link2")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.cmsData,
                                          "action_button_name2"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tls-faq-info" },
                      [
                        _vm._l(
                          _vm._.sortBy(_vm.contentSlotData, "sort"),
                          function(questionAnswer, index) {
                            return [
                              _vm._.get(
                                questionAnswer,
                                "slot_title_translation"
                              )
                                ? _c("div", { key: index }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tls-legal-action--slot",
                                        attrs: {
                                          id: _vm._.get(
                                            questionAnswer,
                                            "anchor"
                                          )
                                        }
                                      },
                                      [
                                        _c("h2", { staticClass: "tls-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._.get(
                                                questionAnswer,
                                                "slot_title_translation"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "dompurify-html",
                                          rawName: "v-dompurify-html",
                                          value: _vm._.get(
                                            questionAnswer,
                                            "long_desc"
                                          ),
                                          expression:
                                            "_.get(questionAnswer, 'long_desc')"
                                        }
                                      ],
                                      staticClass: "tls-simple-text -size-14"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tls-tab-content-paragraph"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "tls-link",
                                            attrs: {
                                              href:
                                                _vm._.get(_vm.path, "path") +
                                                "#top"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-chevron-up"
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._.get(
                                                    _vm.keywords,
                                                    "back_to_the_top"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        )
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ])
          : _vm.isSearchEmpty()
          ? _c("div", [
              _c("div", {
                directives: [
                  {
                    name: "dompurify-html",
                    rawName: "v-dompurify-html",
                    value: _vm._.get(
                      _vm.cmsData,
                      "search_content_empty_prompt"
                    ),
                    expression: "_.get(cmsData, 'search_content_empty_prompt')"
                  }
                ],
                staticClass: "tls-link-list"
              })
            ])
          : _c(
              "div",
              { staticClass: "tls-faq-search-content" },
              _vm._l(_vm.contentSlotData, function(list_item, index) {
                return _vm.isSearchShow(list_item)
                  ? _c("div", { staticClass: "tls-dropdown" }, [
                      _c(
                        "a",
                        {
                          staticClass: "tls-link-dropdown tls-line-height",
                          on: {
                            click: function($event) {
                              return _vm.toggleDropdownFaq(index)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tls-link-dropdown--icon" },
                            [
                              !list_item.dropdown_status
                                ? _c("i", {
                                    staticClass: "fa fa-chevron-circle-right"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              list_item.dropdown_status
                                ? _c("i", {
                                    staticClass: "fa fa-chevron-circle-down"
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tls-link-dropdown--text" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(list_item, "slot_title_translation")
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tls-dropdown--content",
                          class: !list_item.dropdown_status ? "hidden" : ""
                        },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "dompurify-html",
                                rawName: "v-dompurify-html",
                                value: _vm._.get(list_item, "long_desc"),
                                expression: "_.get(list_item, 'long_desc')"
                              }
                            ],
                            staticClass: "tls-simple-text -size-16"
                          }),
                          _vm._v(" "),
                          _vm._.get(_vm.cmsData, "rating")
                            ? _c("hr")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._.get(_vm.cmsData, "rating")
                            ? _c("div", { staticClass: "faq-thump-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "faq-thump-text tls-simple-text -size-16"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(_vm.cmsData, "rating_content")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                list_item.thump_down
                                  ? _c("img", {
                                      staticClass:
                                        "faq-thump-img faq-thump-down",
                                      attrs: {
                                        src: _vm.thumpDownBlackPic,
                                        alt: "thump down"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickThumpDown(index)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !list_item.thump_down
                                  ? _c("img", {
                                      staticClass:
                                        "faq-thump-img faq-thump-down",
                                      attrs: {
                                        src: _vm.thumpDownGreyPic,
                                        alt: "thump down"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickThumpDown(index)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                list_item.thump_up
                                  ? _c("img", {
                                      staticClass: "faq-thump-img faq-thump-up",
                                      attrs: {
                                        src: _vm.thumpUpOrangePic,
                                        alt: "thump up"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickThumpUp(index)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !list_item.thump_up
                                  ? _c("img", {
                                      staticClass: "faq-thump-img faq-thump-up",
                                      attrs: {
                                        src: _vm.thumpUpGreyPic,
                                        alt: "thump up"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickThumpUp(index)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              }),
              0
            )
      ],
      1
    ),
    _vm._v(" "),
    _vm.cmsData.floating_prompt
      ? _c("div", {
          directives: [
            {
              name: "dompurify-html",
              rawName: "v-dompurify-html",
              value: _vm.cmsData.floating_prompt,
              expression: "cmsData.floating_prompt"
            }
          ],
          staticClass: "floating_prompt"
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-large-card-info--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }